export const environment = {
	production: true,
	url: 'https://api.kolink.kogentservices.com:3000',
};
